import { useEffect } from "react";

// Full page load to a /guides/* page — a react-router navigate() would render
// the SPA's 404 shell, since the guides app isn't part of this bundle.
const LegacyGuideRedirect = ({ to }) => {
  useEffect(() => {
    window.location.replace(`${to}${window.location.search}${window.location.hash}`);
  }, [to]);

  return null;
};

export default LegacyGuideRedirect;
